import { css } from "styled-components";
import { typographyMixin } from "../../helpers";
import { TTypographyVariant } from "../../types";
import { ButtonSize } from "./types";

type ButtonSizeStylesMap = {
    textSize: TTypographyVariant;
    padding: string;
    iconSize: number;
    height: number;
    gap: number;
};

const getButtonSizeStylesMap = (size: ButtonSize, iconOnly: boolean): ButtonSizeStylesMap => {
    switch (size) {
        case "lg":
            return {
                textSize: "label-regular-medium",
                padding: iconOnly ? "10px" : "12px 20px",
                iconSize: 24,
                height: 44,
                gap: 12
            };
        case "md":
            return {
                textSize: "label-small-medium",
                padding: iconOnly ? "12px" : "10px 16px",
                iconSize: 16,
                height: 40,
                gap: 8
            };
        case "sm":
        default:
            return {
                textSize: "label-small-medium",
                padding: iconOnly ? "10px" : "8px 14px",
                iconSize: 16,
                height: 36,
                gap: 8
            };
    }
};

/**
 * @internal
 */
export const getButtonSizeStyles = (size: ButtonSize, iconOnly: boolean) => {
    const sizeStyles = getButtonSizeStylesMap(size, iconOnly);

    return css`
        --button-icon-size: ${sizeStyles.iconSize}px;

        ${typographyMixin(sizeStyles.textSize)}
        height: ${sizeStyles.height}px;
        column-gap: ${sizeStyles.gap}px;
        padding: ${sizeStyles.padding};
    `;
};
